import React, { useState } from "react";
import {
  BsClipboardData,
  BsBriefcase,
  BsBuildings,
  BsCheckCircle,
  BsPersonPlus,
  BsArrowUpRight,
} from "react-icons/bs";

import { Link } from "react-router-dom";
import "./Masters.css";
import useLocalStorageState from "use-local-storage-state";
import { AuthorizationCard } from "../../../CommonComponents/AuthorizationCard";

const masterItems = [

  {
    title: "Lead Source",
    description: "Manage enquiry sources used across CRM records.",
    icon: <BsClipboardData />,
    path: "/enquirySource",
  },

  {
    title: "Designation",
    description: "Maintain job titles available to your team.",
    icon: <BsBriefcase />,
    path: "/designation",
  },
  {
    title: "Department",
    description: "Organize users into operational departments.",
    icon: <BsBuildings />,
    path: "/department",
  },
  {
    title: "Shift",
    description: "Define work shifts with timezone and daily timings.",
    icon: <BsPersonPlus />,
    path: "/shift",
  },
  {
    title: "Product and Services",
    description: "Manage products and services for sales and documents.",
    icon: <BsCheckCircle />,
    path: "/product",
  },
  {
    title: "Chart Of Accounts",
    description: "Manage financial accounts used by billing workflows.",
    icon: <BsCheckCircle />,
    path: "/chartOfAccounts",
  },
  {
    title: "Templates",
    description: "Choose the document template used by your organization.",
    icon: <BsCheckCircle />,
    path: "/templates",
  },
  {
    title: "Currency",
    description: "Add and activate currencies for your organization.",
    icon: <BsCheckCircle />,
    path: "/currency",
  },
];

export const Master = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  // rbac permission object
  const [PERMISSION] = useLocalStorageState("permission");

  // master permissions
  const masterGrant = PERMISSION.setting.feature.master;

  return (
    <div className="container masters-page">
      <div
        className="masters-heading mb-4 d-flex flex-column flex-md-row justify-content-between align-items-start gap-3"
      >
        <div className="d-flex align-items-start gap-3">
          <div>
            <h6 className="masters-title mb-1">Masters</h6>
            <p className="text-muted mb-0 small">
              Manage reference data used across CRM modules.
            </p>
          </div>
        </div>
      </div>

      <div className="row g-3 g-xl-4">
        {
          !masterGrant?.isView ?
            <AuthorizationCard></AuthorizationCard>
            :
            masterItems.map((item, index) => (
              <div className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex" key={item.path}>
                <Link to={item.path} className="text-decoration-none text-dark w-100 d-flex">
                  <div
                    className="master-card h-100 w-100 shadow-sm rounded bg-white d-flex flex-column tooltip-custom"
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <div className="icon-box">
                        {React.cloneElement(item.icon, {
                          size: 19,
                          color: "#7a3a5e",
                        })}
                      </div>
                      <span className="master-card__arrow" aria-hidden="true">
                        <BsArrowUpRight size={15} />
                      </span>
                    </div>

                    <div className="text-box mt-3">
                      <h6 className="fw-semibold mb-2 card-title">{item.title}</h6>
                      <p className="text-muted desc-text mb-0">
                        {item.description}
                      </p>
                    </div>

                  </div>
                </Link>
              </div>
            ))
        }
      </div>
    </div>
  );
};
